module.exports = __webpack_public_path__ + "img/7676.742694b0.jpg";